import type { ReactNode } from "react";
import { EditQuestionFormContext } from "./EditQuestionFormContext";
import { useEditQuestionFormGenerator } from "./hooks";

export default function EditQuestionFormProvider({ children }: { children: ReactNode }) {
    const form = useEditQuestionFormGenerator();

    return (
        <EditQuestionFormContext.Provider value={form}>{children}</EditQuestionFormContext.Provider>
    );
}
